export const MULTILINGUAL_LANGUAGES = [
  { value: "gl", labelKey: "form.multilingual_languages.gl" },
  { value: "es", labelKey: "form.multilingual_languages.es" },
  { value: "en", labelKey: "form.multilingual_languages.en" }
];

export function normalizeMultilingualValue(value) {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return MULTILINGUAL_LANGUAGES.reduce((result, language) => {
      result[language.value] = typeof value[language.value] === "string"
        ? value[language.value]
        : "";
      return result;
    }, {});
  }

  return {
    gl: "",
    es: "",
    en: typeof value === "string" ? value : ""
  };
}

export function multilingualHasContent(value) {
  return Object.values(normalizeMultilingualValue(value))
    .some(text => text.replace(/<[^>]+>/g, "").trim());
}
